import React from "react";
import { useTextZoneFontSize } from "../../../hooks/useTextZoneFontSize";
import { TopMenuNumberField } from "./top-menu-numberfield";
import { useLabels } from "../../../hooks/useLabels";
import { labels } from "./labels";

export function TextSizeNumberField() {
	const { currentSize, minSize, maxSize, disabled, onChange } = useTextZoneFontSize();

	const [[fontSizeTooltipText, decreaseFontSizeTooltipText, increaseFontSizeTooltipText]] =
		useLabels([
			labels.fontSizeTooltip,
			labels.decreaseFontSizeTooltip,
			labels.increaseFontSizeTooltip,
		]);
	return (
		<TopMenuNumberField
			disabled={disabled}
			value={currentSize}
			min={minSize}
			max={maxSize}
			onChange={onChange}
			valueTooltipLabel={fontSizeTooltipText}
			decrementTooltipLabel={decreaseFontSizeTooltipText}
			incrementTooltipLabel={increaseFontSizeTooltipText}
		/>
	);
}
